<template>
  <div class="sq-shequ-wrapper" :style="{width:width*0.29+'px'}">
    <div class="sq-header-wrapper">
      <img v-if="shequ.headPic" class="sq-header-pic" :src="shequ.headPic"/>
      <div class="shequ-head slh">
        {{shequ.title}}
      </div>
    </div>
    <y-scroll :contentArr="shequ.info" :height="scrollHeight" :lineNum="1" :width="width*0.29" v-if="shequ.info.length">
      <div slot="scroll" slot-scope="props" class="scroll-wrapper">
        <div v-if="props.todo.str" :class="spanClass">
          {{props.todo.str}}
        </div>
        <div v-else-if="props.todo.img">
          <img class='scroll-pic' :src='props.todo.img' :style="{height:scrollHeight*0.945+'px'}" />
        </div>
      </div>
    </y-scroll>
  </div>
</template>
<script>
  import yScroll from '../../../components/yScroll'
  export default {
    components: {
      yScroll
    },
    props:{
      height:null,
      width:null,
      shequ:{
        type:Object,
        default:{
          title:'',
          info:[]
        }
      }
    },
    computed: {
      scrollHeight () {
        return this.height>400?this.height*0.70:this.no125?this.height * 0.65:this.height * 0.60
      },
      no125 () {
        return this.height/0.436>750 || this.width > 1550?true:false
      },
      spanClass () {
        // var no125 = this.height/0.436>750 || this.width > 1550?true:false
        return this.height>400?'shequ-span1':this.no125?'shequ-span2':'shequ-span3'
      }
    },
    data () {
      return {

      }

    }
  }
</script>

<style>
  .sq-shequ-wrapper{
    /*width: 575px;*/
    background: #fff;
    border: 1px solid #fff;
    border-radius: 5px;

  }
  .sq-header-wrapper{
    margin:5.395% 0;
    height: 50px;
    text-align: center;
    display: flex;
    justify-content: center
  }
  .shequ-head{
    font-size: 48px;
    text-align: center;
    color: #4a4a4a;
    vertical-align: top;
    line-height: 50px;
    height:50px
  }
  .sq-header-pic {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 20px;
  }
  .shequ-span1{
    color: #676767;
    text-indent:50px;
    line-height: 40px;
    font-size: 25px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 8;
    overflow: hidden;
    height: 100%;
  }
  .scroll-pic{
    /*width: 535px;*/
    width:100%;
    height: 100%;
  }
  .scroll-wrapper{
    height: 100%;
    padding: 0 15px;
    display: flex;
    align-items: center;
  }
  .duohang-slh{

  }
   @media screen and (min-width: 1680px){
      .shequ-span2{
        color: #676767;
        text-indent:50px;
        font-size: 23px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 7;
        overflow: hidden;
        height: 100%;
      }
      .shequ-span3{
        color: #676767;
        text-indent:50px;
        font-size: 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
        overflow: hidden;
        height: 100%;
      }
  }
  @media screen and (max-width:1679px){
      .shequ-span2{
        text-indent:40px;
        font-size: 20px;
      }
      .shequ-span3{
        text-indent:40px;
        font-size: 18px;
      }
  }
</style>

